import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { delayMs, randomNumber } from './ChoasModeUtil.js';

var shouldAlwaysFail = function shouldAlwaysFail(context, alwaysFail) {
  if (alwaysFail === '') {
    return false;
  }
  if (context.arguments.mutation) {
    var _query = context.arguments.mutation.loc.source.body;
    return alwaysFail.split(',').some(function (q) {
      return _query.includes(q);
    });
  }
  var query = context.arguments.query.loc.source.body;
  return alwaysFail.split(',').some(function (q) {
    return query.includes(q);
  });
};
var shouldNeverFail = function shouldNeverFail(context, neverFail) {
  if (neverFail === '') {
    return false;
  }
  if (context.arguments.mutation) {
    var _query2 = context.arguments.mutation.loc.source.body;
    return neverFail.split(',').some(function (q) {
      return _query2.includes(q);
    });
  }
  var query = context.arguments.query.loc.source.body;
  return neverFail.split(',').some(function (q) {
    return query.includes(q);
  });
};
var chaosMode = function chaosMode() {
  return function (fun) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(context) {
        var chaosModeMaxDelay, chaosModeErrorFrequency, neverFail, alwaysFail, chaosDelayTotal, chaosDelayBefore, chaosDelayAfter, hasError, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                chaosModeMaxDelay = localStorage.getItem('CHAOS_MODE_MAX_DELAY') || 0;
                chaosModeErrorFrequency = localStorage.getItem('CHAOS_MODE_ERROR_FREQUENCY') || 0; // comma separated list of queries that should never fail
                neverFail = localStorage.getItem('CHAOS_MODE_NEVER_FAIL') || ''; // comma separated list of queries that should always succeed
                alwaysFail = localStorage.getItem('CHAOS_MODE_ALWAYS_FAIL') || '';
                chaosDelayTotal = randomNumber() * chaosModeMaxDelay;
                chaosDelayBefore = randomNumber() * chaosDelayTotal;
                chaosDelayAfter = chaosDelayTotal - chaosDelayBefore;
                hasError = randomNumber() < chaosModeErrorFrequency;
                _context.next = 10;
                return delayMs(chaosDelayBefore);
              case 10:
                _context.next = 12;
                return fun(context);
              case 12:
                result = _context.sent;
                _context.next = 15;
                return delayMs(chaosDelayAfter);
              case 15:
                if (!(!shouldNeverFail(context, neverFail) && (hasError || shouldAlwaysFail(context, alwaysFail)))) {
                  _context.next = 19;
                  break;
                }
                console.log('Will reject');
                console.log(context);
                // eslint-disable-next-line prefer-promise-reject-errors
                return _context.abrupt("return", Promise.reject({
                  graphQLErrors: [],
                  data: {}
                }));
              case 19:
                return _context.abrupt("return", result);
              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};

export { chaosMode };
